import PropTypes from 'prop-types';
// @mui
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
// auth
import { useAuthContext } from 'src/auth/hooks';
// routes
import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// theme
import { bgGradient } from 'src/theme/css';
// components
import Logo, { LogoWhite } from 'src/components/logo';

// ----------------------------------------------------------------------

const METHODS = [
  {
    id: 'jwt',
    label: 'Patient Login',
    path: paths.auth.jwt.login,
    icon: '/assets/icons/auth/examination.png',
  },
  {
    id: 'firebase',
    label: 'Doctor Login',
    path: '#',
    icon: '/assets/icons/auth/doctor.png',
  },
  {
    id: 'amplify',
    label: 'Pharmacy Login',
    path: '#',
    icon: '/assets/icons/auth/pharmacy.png',
  },
  {
    id: 'auth0',
    label: 'Hospital Login',
    path: '#',
    icon: '/assets/icons/auth/hospital.png',
  },
];

export default function AuthClassicOptLayout({ children, image, title }) {
  const { method } = useAuthContext();

  const theme = useTheme();

  const upMd = useResponsive('up', 'md');

  const renderLogo = (
    // <Logo
    //   sx={{
    //     zIndex: 9,
    //     position: 'absolute',
    //     m: { xs: 2, md: 5 },
    //     mb: { md: 0 },
    //     mt: { md: 0 },
    //     width: 100,
    //     height: 100,
    //   }}
    // />
    <Logo
      sx={{
        zIndex: 9,
        position: 'absolute',
        m: { xs: 2, md: 5 },
        mb: { md: 3 },
        mt: { md: 3 },
        display: { xs: 'block', md: 'none' },
      }}
    />
  );

  const renderContent = (
    <Stack
      sx={{
        width: 1,
        mx: 'auto',
        maxWidth: 500,
        px: { xs: 2, md: 2 },
        py: { xs: 15, md: 15 },
        position: 'relative',
      }}
    >
      {' '}
      {/* <Logo
        sx={{
          zIndex: 9,
          position: 'absolute',
          top: '10px',
          right: '10px',
          m: { xs: 2 },
          mb: { md: 10 },
          display: { xs: 'none', md: 'block' },
          // mt: { md: 3 },
        }}
      /> */}
      {children}
    </Stack>
  );

  const renderSection = (
    <Stack
      flexGrow={1}
      alignItems="center"
      justifyContent="center"
      spacing={10}
      sx={{
        height: '100vh',
        maxWidth: '90%',
        zIndex: 8,
        position: 'sticky',
        top: 0,
        '@media (max-width: 1200px)': {
          maxWidth: '60%',
        },
        backgroundImage: `url(${image})`,
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    >
      <LogoWhite
        sx={{
          zIndex: 9,
          position: 'absolute',
          top: '10px',
          left: '10px',
          m: { xs: 2 },
          mb: { md: 10 },
          display: { xs: 'none', md: 'block' },
          // mt: { md: 3 },
        }}
      />

      <Typography variant="h3" sx={{ maxWidth: 480, textAlign: 'center' }}>
        {title}
      </Typography>

      <Stack
        sx={{
          position: 'absolute',
          top: '0',
          width: '100%',
          height: '100%',
          backgroundColor: theme.palette.mode === 'light' ? 'transparent' : '#0000000d',
        }}
      />
    </Stack>
  );

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        minHeight: '100vh',
      }}
    >
      {renderLogo}

      {upMd && renderSection}

      {renderContent}
    </Stack>
  );
}

AuthClassicOptLayout.propTypes = {
  children: PropTypes.node,
  image: PropTypes.string,
  title: PropTypes.string,
};
